import React from 'react';
import { TableBody, Typography } from '@mui/material';
import Spinner from '../../../assets/svg/spinner';
import { StyledEmptyCell, StyledEmptyRow } from './TableStates.styles';

/**
 * Component to display the charging status
 */
export const LoadingState = ({ tableColumnsCount }) => (
  <TableBody>
    <StyledEmptyRow>
      <StyledEmptyCell colSpan={tableColumnsCount}>
        <Spinner />
      </StyledEmptyCell>
    </StyledEmptyRow>
  </TableBody>
);

/**
 * Component to display empty state
 */
export const EmptyState = ({ tableColumnsCount }) => (
  <TableBody>
    <StyledEmptyRow>
      <StyledEmptyCell colSpan={tableColumnsCount}>
        <Typography variant="body2">No violations found</Typography>
      </StyledEmptyCell>
    </StyledEmptyRow>
  </TableBody>
);
